import * as React from 'react';

function SvgJoinTelegram(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={19.872} height={18.283} {...props}>
      <path
        data-name="join telegram"
        d="M2.732 0H17.14a2.735 2.735 0 012.732 2.732v8.818a2.735 2.735 0 01-2.722 2.732v4l-5.75-4H2.732A2.735 2.735 0 01-.001 11.55V2.732A2.735 2.735 0 012.732 0zm2.587 10.247h9.235V9.083H5.319zm0-2.484h9.235V6.599H5.319zm0-2.484h9.235V4.115H5.319zm0 0"
        fill={props.fill}
      />
    </svg>
  );
}

export default SvgJoinTelegram;
